import React from 'react';
import ReactDOM from 'react-dom';
import './fonts.css';
import './index.css';
import App from './app';

ReactDOM.render(<App configPath='config.yml'/>, document.getElementById('root'));